import Dialog from './dialog.vue'
export default Dialog



// WEBPACK FOOTER //
// ./src/components/dialog/index.js